import { setTimedFlagFromUrlParam } from '@oskecare/fe-utilities/lib/timedFlag';

/**
 * @param {string} str
 * @returns {boolean|string}
 */
function parseBoolString(str) {
  switch (str.toLowerCase().trim()) {
    case 'true':
      return true;
    case 'false':
      return false;
    default:
      return str;
  }
}

const env = variable => {
  if (window.env === undefined) {
    throw new Error('window.env is not defined.');
  }
  if (window.env[variable] === undefined) {
    throw new Error(`window.env.${variable} is not defined.`);
  }
  return parseBoolString(window.env[variable]);
};

const envMapping = new Map([
  // API URLs
  ['monicaApiUrl', 'EC2_FE_MONICA_API_URL'],
  ['natalieApiUrl', 'EC2_FE_NATALIE_API_URL'],
  ['oliviaApiUrl', 'EC2_FE_OLIVIA_API_URL'],

  // API WSO2 URLs
  ['apiKey', 'EC2_FE_OST_API_KEY'],
  ['autocompleteApiUrl', 'EC2_FE_AUTOCOMPLETE_API_URL'],
  ['billingAccountApiUrl', 'EC2_FE_BILLING_ACCOUNT_API_URL'],
  ['consumptionApiUrl', 'EC2_FE_CONSUMPTION_API_URL'],
  ['cpmBinaryApiUrl', 'EC2_FE_CPM_BINARY_API_URL'],
  ['customerApiUrl', 'EC2_FE_CUSTOMER_API_URL'],
  ['customerBillCalculationApiUrl', 'EC2_FE_CUSTOMER_BILL_CALCULATION_API_URL'],
  ['customerInformationManagementApiUrl', 'EC2_FE_CUSTOMER_INFORMATION_MANAGEMENT_API_URL'],
  ['customerProblemApiUrl', 'EC2_FE_CUSTOMER_PROBLEM_API_URL'],
  ['gigamarketInfoV2ApiUrl', 'EC2_FE_GIGAMARKET_INFO_V2_API_URL'],
  ['loyaltyApiUrl', 'EC2_FE_LOYALTY_API_URL'],
  ['notificationsApiUrl', 'EC2_FE_NOTIFICATIONS_API_URL'],
  ['ostApiUrl', 'EC2_FE_OST_API_URL'],
  ['outagesApiUrl', 'EC2_FE_OUTAGES_API_URL'],
  ['paymentManagementApiUrl', 'EC2_FE_PAYMENT_MANAGEMENT_API_URL'],
  ['paymentManagementV2ApiUrl', 'EC2_FE_PAYMENT_MANAGEMENT_V2_API_URL'],
  ['paymentMethodApiUrl', 'EC2_FE_PAYMENT_METHOD_API_URL'],
  ['prepaidBalanceRechargeApiUrl', 'EC2_FE_PREPAID_BALANCE_RECHARGE_API_URL'],
  ['productApiUrl', 'EC2_FE_PRODUCT_API_URL'],
  ['productDomainApiUrl', 'EC2_FE_PRODUCT_DOMAIN_API_URL'],
  ['productOfferingApiUrl', 'EC2_FE_PRODUCT_OFFERING_API_URL'],
  ['productOrderV1ApiUrl', 'EC2_FE_PRODUCT_ORDER_V1_API_URL'],
  ['productOrderV2ApiUrl', 'EC2_FE_PRODUCT_ORDER_V2_API_URL'],
  ['resourceInventoryManagementApiUrl', 'EC2_FE_RESOURCE_INVENTORY_MANAGEMENT_API_URL'],
  ['idCodeApiUrl', 'EC2_FE_ID_CODE_API_URL'],
  ['salesManagementApiUrl', 'EC2_FE_SALES_MANAGEMENT_API_URL'],
  ['subscriptionApiUrl', 'EC2_FE_SUBSCRIPTION_API_URL'],
  ['usageManagementApiUrl', 'EC2_FE_USAGE_MANAGEMENT_API_URL'],

  // Widget URLs
  ['astridWidgetUrl', 'EC2_FE_ASTRID_WIDGET_URL'],
  ['bonnieWidgetUrl', 'EC2_FE_BONNIE_WIDGET_URL'],
  ['crystalWidgetUrl', 'EC2_FE_CRYSTAL_WIDGET_URL'],
  ['francescaWidgetUrl', 'EC2_FE_FRANCESCA_WIDGET_URL'],
  ['ireneWidgetUrl', 'EC2_FE_IRENE_WIDGET_URL'],
  ['jodieWidgetUrl', 'EC2_FE_JODIE_WIDGET_URL'],
  ['karenWidgetUrl', 'EC2_FE_KAREN_WIDGET_URL'],
  ['lucyWidgetUrl', 'EC2_FE_LUCY_WIDGET_URL'],
  ['margaretWidgetUrl', 'EC2_FE_MARGARET_WIDGET_URL'],
  ['sabrinaWidgetUrl', 'EC2_FE_SABRINA_WIDGET_URL'],
  ['sashaWidgetUrl', 'EC2_FE_SASHA_WIDGET_URL'],
  ['teganWidgetUrl', 'EC2_FE_TEGAN_WIDGET_URL'],
  ['valentinaWidgetUrl', 'EC2_FE_VALENTINA_WIDGET_URL'],
  ['villanelleWidgetUrl', 'EC2_FE_VILLANELLE_WIDGET_URL'],

  // App settings
  ['basePath', 'EC2_FE_BASE_PATH'],
  ['authServerUrl', 'EC2_FE_AUTH_SERVER_URL'],
  ['invoiceBaseUrl', 'EC2_FE_INVOICE_BASE_URL'],
  ['partialLogoutUrl', 'EC2_FE_PARTIAL_LOGOUT_URL'],
  ['authCustomerAdminConfirmLink', 'EC2_FE_AUTH_CUSTOMER_ADMIN_CONFIRMATION_LINK'],
  ['einvoiceActivationLink', 'EC2_FE_EINVOICE_ACTIVATION_LINK'],
  ['fillCreditLink', 'EC2_FE_FILL_CREDIT_LINK'],
  ['creditToolTipLink', 'EC2_FE_LINDSEY_TOOLTIP_URL'],
  ['clientId', 'EC2_FE_CLIENT_ID'],
  ['userRole', 'EC2_FE_USER_ROLE'],
  ['customerAdminRole', 'EC2_FE_CUSTOMER_ADMIN_ROLE'],
  ['mhubCode', 'EC2_FE_MHUB_CODE'],
  ['idTokenCookieName', 'EC2_FE_IDTOKEN_COOKIE_NAME'],
  ['iframeRefreshInterval', 'EC2_FE_IFRAME_REFRESH_INTERVAL'],
  ['allowWipFeatures', 'EC2_FE_ALLOW_WIP_FEATURES'],
  ['showAllCompetitions', 'EC2_FE_SHOW_ALL_COMPETITIONS'],
  ['loyaltyHasMaintenanceNotice', 'EC2_FE_LOYALTY_HAS_MAINTENANCE_NOTICE'],
  ['orangeSkBaseUrl', 'EC2_FE_ORANGE_SK_BASE_URL'], // TODO maybe move to other section?
  ['bypassErrors', 'EC2_FE_BYPASS_ERRORS'],
  ['showMaintenanceMessage', 'EC2_FE_SHOW_MAINTENANCE_MESSAGE'],
  ['genesysChatScriptUrl', 'EC2_FE_GENESYS_CHAT_SCRIPT_URL'],
  ['footerJsonSourceUrl', 'EC2_FE_FOOTER_JSON_SOURCE_URL'],
  ['allowGtm', 'EC2_FE_ALLOW_GTM'],

  // Log settings
  ['logApiUrl', 'EC2_FE_LOG_API_URL'],
  ['logConsoleOutput', 'EC2_FE_LOG_CONSOLE_OUTPUT'],
  ['logMinLoggedSeverity', 'EC2_FE_LOG_MIN_LOGGED_SEVERITY'],
  ['logSendToBackend', 'EC2_FE_LOG_SEND_TO_BACKEND'],
]);

const applicationConfig = new Map([
  ['consumptionDetailCustomerCategories', ['TELE/FAX/DATA', 'EMPLOYEE']],
  ['previousConsumptionCustomerCategories', ['TELE/FAX/DATA', 'EMPLOYEE', 'FIXLTE', 'LANDLINE']],
]);

const linkConfig = new Map([
  ['consumptionLink', 'spotreba'],
  ['actualDetailConsumptionLink', 'spotreba/aktualna-spotreba'],
  ['previousConsumptionLink', 'spotreba/predosla-spotreba'],
  ['PRH_ConsumptionLink', 'spotreba/podrobny-vypis'],
  ['consumptionPurchaseHistoryLink', 'spotreba/historia-nakupov'],
  ['invoiceLink', 'faktury'],
  ['invoicePayLink', 'faktury/platba'],
  ['creditLink', 'kredit'],
  ['creditAutomaticRefillLink', 'kredit/automaticke-dobitie'],
  ['postpaidCreditLink', 'produkty-a-sluzby/kredit'],
  ['postpaidCreditAutomaticRefillLink', 'produkty-a-sluzby/kredit/automaticke-dobitie'],
  ['productsAndServicesLink', 'produkty-a-sluzby'],
  ['productsAndServicesOverviewLink', 'produkty-a-sluzby/prehlad'],
  ['productsAndServicesEligibleLink', 'produkty-a-sluzby/prehlad/vsetky-sluzby'],
  ['productsAndServicesDetailLink', 'produkty-a-sluzby/prehlad/detail'],
  ['productsAndServicesTogetherFree', 'produkty-a-sluzby/prehlad/navzajom-zadarmo'],
  [
    'productsAndServicesEInvoiceDetailLink',
    'produkty-a-sluzby/prehlad/detail?sluzba=10503007-elektronicka-faktura',
  ],
  [
    'productsAndServicesShsTopUpLink',
    'produkty-a-sluzby/prehlad/detail?sluzba=10542731-jednorazove-navysenie-objemu-dat',
  ],
  [
    'productsAndServicesPrepaidChainBenefitInitialOfferLink',
    'produkty-a-sluzby/prehlad/detail?sluzba=13198091-benefit-100-gb',
  ],
  [
    'productsAndServicesPostpaidChristmasOfferLink',
    'produkty-a-sluzby/prehlad/detail?sluzba=13198090-benefit-100-gb',
  ],
  [
    'productsAndServicesPrepaidStarterPackDataBenefitLink',
    'produkty-a-sluzby/prehlad/detail?sluzba=13294573-benefit-10-gb',
  ],
  [
    'productsAndServicesPrepaidStarterPackVoiceBenefitLink',
    'produkty-a-sluzby/prehlad/detail?sluzba=13394459-nekonecne-hovory-na-3-cisla-v-sieti-orange-na-3-mesiace-zadarmo',
  ],
  ['dataSharingPageLink', 'produkty-a-sluzby/prehlad/zdielam-svoje-data'],
  ['dataMergePageLink', 'produkty-a-sluzby/prehlad/spojenie-dat'],
  ['loveLink', 'produkty-a-sluzby/love'],
  ['gigamarketLink', 'yoxomarket'],
  ['dashboardLink', ''],
  ['errorLink', 'chyba'],
  ['accountSettingsLink', 'nastavenie-uctu'],
  ['mySimLink', 'nastavenie-uctu/sprava-sim-karty'],
  ['eSimActivationLink', 'nastavenie-uctu/sprava-sim-karty/aktivacia-esim'],
  ['eSimDeactivationLink', 'nastavenie-uctu/sprava-sim-karty/deaktivacia-esim'],
  ['eSimRegenerateLink', 'nastavenie-uctu/sprava-sim-karty/vygenerovanie-esim'],
  ['masterSnManagementLink', 'nastavenie-uctu/hlavny-ucet'],
  ['claimsAndRequestsLink', 'riesenie-problemov'],
  ['claimsAndRequestsDetailLink', 'riesenie-problemov/detail'],
  ['loyaltyDashboardLink', 'orange-svojim'],
  ['loyaltyMissionsLink', 'orange-svojim/misie'],
  ['loyaltyCelebrationsLink', 'orange-svojim/oslavy'],
  ['loyaltyCelebrationsCouponsLink', 'orange-svojim/odmena-za-vernost'],
  ['loyaltyCompetitionDetailLink', 'orange-svojim/prekvapenia'],
  ['campaignUniverseLink', 'ponuky-pre-vas'],
]);

function getConfig() {
  const cfg = {};

  envMapping.forEach((value, key) => {
    cfg[key] = env(value);
  });

  applicationConfig.forEach((value, key) => {
    cfg[key] = value;
  });

  const basePath = env('EC2_FE_BASE_PATH');
  cfg.linkConfiguration = {};
  linkConfig.forEach((value, key) => {
    cfg.linkConfiguration[key] = `${basePath}${value}`;
  });

  updateWipMode(cfg);
  updateBypass(cfg);
  updateToggleGtmScript(cfg);

  return Object.freeze(cfg);
}

/**
 * Override WIP flag set by the ENV variables with a special URL query parameter.
 * Designed specifically to allow testing WIP features in production.
 *
 * The query parameter sets a timed flag persisted in local storage, param value can be empty or timeout in minutes.
 * @see setTimedFlagFromUrlParam
 * @property {object} config
 */
function updateWipMode(config) {
  const isWipModeOn = setTimedFlagFromUrlParam('wip', 'ec2fe-wip-mode-expiration-time');
  if (isWipModeOn) {
    // eslint-disable-next-line no-param-reassign
    config.allowWipFeatures = true;
  }
}

/**
 * Override bypass flag set by the ENV variables with a special URL query parameter.
 * Designed specifically to allow bypassing various errors and checks for testing purposes.
 *
 * The query parameter sets a timed flag persisted in local storage, param value can be empty or timeout in minutes.
 * @see setTimedFlagFromUrlParam
 * @property {object} config
 */
function updateBypass(config) {
  const isBypassModeOn = setTimedFlagFromUrlParam('bypass', 'ec2fe-bypass-mode-expiration-time');
  if (isBypassModeOn) {
    // eslint-disable-next-line no-param-reassign
    config.bypassErrors = true;
  }
}

/**
 * Override allowGtm flag set by the ENV variable with a special URL query parameter. Enabling the value will toggle
 * to the opposite setting set by the ENV - if it's ON it will be turned OFF and when it's OFF it will be turned ON.
 * Designed specifically to disable third-party scripts e.g. GTM for testing purposes.
 *
 * The query parameter sets a timed flag persisted in local storage, param value can be empty or timeout in minutes.
 * @see setTimedFlagFromUrlParam
 * @property {object} config
 */
function updateToggleGtmScript(config) {
  // eslint-disable-next-line no-param-reassign
  config.allowGtm =
    config.allowGtm !== setTimedFlagFromUrlParam('toggle-gtm', 'ec2fe-toggle-gtm-expiration-time');
}

export const config = getConfig();
